import { render, staticRenderFns } from "./data-china-beef-imports.vue?vue&type=template&id=1bf7231e&scoped=true&"
import script from "./data-china-beef-imports.vue?vue&type=script&lang=js&"
export * from "./data-china-beef-imports.vue?vue&type=script&lang=js&"
import style0 from "./data-china-beef-imports.vue?vue&type=style&index=0&id=1bf7231e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7231e",
  null
  
)

export default component.exports